/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../services.ts"/>


namespace DealerwareWebServices {
    "use strict";

    export class DealerwareSearchAliases implements IDealerwareSearchAliases {

        public aliasData: any;

        // E.g. given:
        //
        // [ 'rented', 'staged', 'in_prep', 'returned', 'maintenance',
        //   'in_port_or_transit', 'received_mco', 'in_pdi', 'needs_registration',
        //   'hard_hold', 'shuttle', 'totaled_pending_ins'
        // ]
        //
        // return the alias for that collection of states: 'all'
        //
        public getAlias ( aliasedItemsToCheck?: string[] ) : string {

            aliasedItemsToCheck = aliasedItemsToCheck || [ ];

            var rv: any = null;

            Object.keys(this.aliasData).some( ( aliasName: string) => {

                var aliasedItems: any = (<any>this.aliasData)[aliasName];

                if (aliasedItemsToCheck.length === aliasedItems.length) {

                    var checkHash = { };
                    aliasedItems.forEach( (aliasedItem: string) => {
                        (<any>checkHash)[aliasedItem] = true;
                    });

                    rv = aliasedItemsToCheck.every( ( aliasedItemToCheck: string ) => {
                        return (<any>checkHash)[aliasedItemToCheck];
                    }) ? aliasName : null;

                    return rv;
                }
            });

            return rv;
        }

        // Input and output the opposite of getAlaias above.
        //
        public getAliasedItems (aliasName: string) : string[] {
            return this.aliasData[aliasName] || [ ];
        }
    }

    getDealerwareWebServicesModule()
        .service('$dealerwareSearchAliases', DealerwareSearchAliases);

}